module.exports = __webpack_public_path__ + "static/img/8.8bb9917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/8.jpg
// module id = ZxhC
// module chunks = 0